import React from 'react';
import HeaderSdr from '../components/sdr-style/HeaderSdr';
import HeroSdr from '../components/sdr-style/HeroSdr';
import ServicesSdr from '../components/sdr-style/ServicesSdr';
import WhyUsSdr from '../components/sdr-style/WhyUsSdr';
import ProcessSdr from '../components/sdr-style/ProcessSdr';
import FaqSdr from '../components/sdr-style/FaqSdr';
import CtaSdr from '../components/sdr-style/CtaSdr';
import FooterSdr from '../components/sdr-style/FooterSdr';

const HomeSdrStyle = () => {
  return (
    <>
      <HeaderSdr />
      <main>
        <HeroSdr />
        <ServicesSdr />
        <WhyUsSdr />
        <ProcessSdr />
        <FaqSdr />
        <CtaSdr />
      </main>
      <FooterSdr />
    </>
  );
};

export default HomeSdrStyle;
